import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { environment as env } from 'src/environments/environment';
import { BehaviorSubject, Observable, Subscription, timer, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

const NOTIFICATIONS_POLL_MS = 60_000;

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  notifications$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  private notificationsPollSub?: Subscription;
  constructor(private readonly http: HttpService) {}

  private fetchNotifications$(): Observable<any[]> {
    return this.http.get<any>(env.baseUrl + `Notification`, { noLoader: true }).pipe(
      map((response) => response?.data?.list || []),
      catchError(() => of([]))
    );
  }

  getAllNotifications(): void {
    this.fetchNotifications$().subscribe((list) => this.notifications$.next(list));
  }

  startNotificationsPolling(): void {
    this.stopNotificationsPolling();
    this.notificationsPollSub = timer(0, NOTIFICATIONS_POLL_MS)
      .pipe(switchMap(() => this.fetchNotifications$()))
      .subscribe((list) => this.notifications$.next(list));
  }

  stopNotificationsPolling(): void {
    this.notificationsPollSub?.unsubscribe();
    this.notificationsPollSub = undefined;
  }

  markAsRead(notificationId: number): Observable<any> {
    return this.http.put<any>(env.baseUrl + `Notification/${notificationId}`, { read: true }, { noLoader: true });
  }
}
